import { useAuth } from '@/contexts/AuthContext';
import bustlyLogo from '@common/assets/icons/logo.svg';
import { SignOut } from '@phosphor-icons/react';
import React from 'react';

const ClientAuth: React.FC = () => {
    const { logout } = useAuth();

    return (
        <div className="w-full inset-0 z-[90] flex flex-col items-center justify-center bg-gray-50">
            <div className="absolute top-6 right-6 z-[92]">
                <button
                    onClick={logout}
                    className="flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-md border border-gray-200/50 rounded-full shadow-sm hover:bg-white hover:shadow-md transition-all group"
                >
                    <SignOut size={16} className="text-gray-500 group-hover:text-gray-800" weight="bold" />
                    <span className="text-sm font-medium text-gray-500 group-hover:text-gray-800">Log out</span>
                </button>
            </div>
            <div className="flex flex-col items-center space-y-6 animate-in fade-in zoom-in-95 duration-500">
                <img src={bustlyLogo} alt="Bustly" className="h-16 w-auto object-contain" />
                <div className="text-center space-y-3">
                    <h1 className="text-2xl font-bold text-[#1A162F]">
                        Please Return to Bustly Client to Continue
                    </h1>
                    <div className="flex items-center justify-center gap-3">
                        <a
                            href="https://www.bustly.shop/download"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center justify-center px-4 py-2 rounded-full border border-[#1A162F]/20 text-[#1A162F] text-sm font-medium bg-white hover:bg-gray-50 transition-colors"
                        >
                            Download
                        </a>
                        <button
                            type="button"
                            onClick={() => {
                                window.location.href = 'bustly://open';
                            }}
                            className="inline-flex items-center justify-center px-4 py-2 rounded-full bg-[#1A162F] text-white text-sm font-medium hover:opacity-90 transition-opacity"
                        >
                            Open Bustly
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientAuth;
